import { SET_MOVE_FLOATING_BUTTON } from './types';

export const setMoveFloatingButton = data => ({
  type: SET_MOVE_FLOATING_BUTTON,
  payload: data,
});
